import { render, staticRenderFns } from "./schoolQuestion.vue?vue&type=template&id=83a33c5e&scoped=true&"
import script from "./schoolQuestion.vue?vue&type=script&lang=js&"
export * from "./schoolQuestion.vue?vue&type=script&lang=js&"
import style0 from "./schoolQuestion.vue?vue&type=style&index=0&id=83a33c5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a33c5e",
  null
  
)

export default component.exports